import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css"
import "./components/global/primary.css";
import "./components/global/grid.css";
import ErrorComponent from "./components/ErrorComponent/ErrorComponent";
import AgentSre from "./pages/AgentSre";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AgentSre />} />
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
